import Vue from 'vue'

/**
 * Generate a unique component identifier.
 *
 * @return {String} The generated component identifier.
 */
export function identifier (length = 5) {
  return Math.random().toString(36).substr(2, length)
}

export function sort (array, order, comparator = (a, b) => a < b ? -1 : a > b ? 1 : 0) {
  switch (order) {
    case 'ascending':
      return array.sort(comparator)
    case 'descending':
    default:
      return array.sort((a, b) => comparator(b, a))
  }
}

export function sortBy (array, order, property) {
  return this.$sort(array, order, (a, b) => {
    a = a[property]
    b = b[property]
    return a < b ? -1 : a > b ? 1 : 0
  })
}

/**
 * Copy some text to the clipboard.
 *
 * @param {String|Node} text
 */
export function clipboard (text = '') {
  let textarea
  let remove = false

  switch (text.constructor) {
    case String:
      textarea = document.createElement('textarea')
      remove = true

      textarea.value = text

      // Ensure that the textarea remains hidden when inserted into the DOM.
      // This ensures that even if the element is somehow rendered before
      // being removed from the DOM again, no flashing occurs.
      textarea.classList.add('is-hidden')

      document.body.appendChild(textarea)
      break

    default:
      textarea = text
  }

  textarea.select()

  let success

  try {
    success = document.execCommand('copy')
  } catch (err) {
    success = false
  }

  if (remove) {
    document.body.removeChild(textarea)
  }

  return success
}

Vue.mixin({
  methods: {
    $identifier: identifier,
    $sort: sort,
    $sortBy: sortBy,
    $clipboard: clipboard
  }
})
